import React from 'react';
import krishImg from '../images/krish.jpg';

const About = () => (
  <section
    id="about"
    style={{ background: '#090c12', borderTop: '1px solid rgba(255,255,255,0.05)' }}
  >
    <div
      className="zk-grid-about zk-section-pad zk-section-gutter"
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: '120px 56px',
        display: 'grid',
        gridTemplateColumns: '360px 1fr',
        gap: '64px',
        alignItems: 'start',
      }}
    >
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            inset: '-14px',
            background:
              'radial-gradient(ellipse at 50% 30%, rgba(56,224,255,0.22), rgba(255,62,165,0.12) 55%, transparent 75%)',
            filter: 'blur(8px)',
            zIndex: 0,
          }}
        />
        <img
          src={krishImg}
          alt="Krish Gupta, founder of Zohtek"
          style={{
            position: 'relative',
            zIndex: 1,
            width: '100%',
            borderRadius: '4px',
            border: '1px solid rgba(255,255,255,0.12)',
            display: 'block',
          }}
        />
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            marginTop: '18px',
            fontFamily: 'var(--zk-mono)',
            fontSize: '12px',
            letterSpacing: '0.08em',
            color: 'rgba(232,238,240,0.6)',
          }}
        >
          <div style={{ color: '#fff', fontSize: '14px', letterSpacing: '0.04em', marginBottom: '4px' }}>
            Krish Gupta
          </div>
          Founder · Data &amp; AI Practitioner
        </div>
      </div>

      <div>
        <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '12px', letterSpacing: '0.28em', color: '#ff3ea5' }}>
          {'// ABOUT'}
        </span>
        <h2
          style={{
            margin: '18px 0 28px',
            fontSize: 'clamp(30px, 3.4vw, 44px)',
            fontWeight: 600,
            letterSpacing: '-0.02em',
            lineHeight: 1.08,
          }}
        >
          Depth in the maths and the engineering.
        </h2>
        <p style={{ margin: '0 0 22px', fontSize: '17px', lineHeight: 1.68, color: 'rgba(232,238,240,0.8)', textWrap: 'pretty' }}>
          Zohtek is led by Krish Gupta, a data and AI practitioner based in Melbourne. The background is unusual on purpose: production software and machine learning engineering across government, enterprise, and GIS work, built on a foundation in economics and a Master of Mathematics in stochastic processes and optimisation.
        </p>
        <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.68, color: 'rgba(232,238,240,0.8)', textWrap: 'pretty' }}>
          That mix is the point. A lot of data work fails because the maths is thin or the engineering is thin. The aim here is depth in both: rigorous enough to model the hard problems, and practical enough to ship something your team can actually run. Australian and US citizen, based in Melbourne. Everything is handled in-house, by the person you hire, with your data kept in Australian-region infrastructure and treated as carefully as you would treat it yourself. Available across Australia, remote and on-site.
        </p>
      </div>
    </div>
  </section>
);

export default About;
